import React from "react"
import {
	Button as LDButton,
	PolymorphicButton,
} from "@walmart-web/livingdesign-components"

const Button: React.FC<PolymorphicButton> = ({ children, ...props }) => {
	return <LDButton {...props}>{children}</LDButton>
}

export default Button
